import { createFileRoute } from '@tanstack/react-router'
import { LegacyMatchAliasRecovery } from '~/features/football-match-detail/football-match-detail'
import { loadLegacyMatchAliasRoute } from '~/features/football-match-detail/legacy-route-options'
import { handleLegacyMatchAliasRequest } from '~/features/football-match-detail/legacy-server-handler'

export const Route = createFileRoute('/research/matches/$matchId')({
  server: {
    handlers: {
      GET: ({ request, params }) => handleLegacyMatchAliasRequest({
        request,
        sourceKind: 'research_match',
        sourceId: params.matchId,
        locale: 'en',
      }),
    },
  },
  loader: ({ params, location }) => loadLegacyMatchAliasRoute({
    sourceKind: 'research_match',
    sourceId: params.matchId,
    locale: 'en',
    location,
  }),
  component: ResearchMatchLegacyRoute,
  notFoundComponent: () => <LegacyMatchAliasRecovery locale="en" kind="not_found" />,
})

function ResearchMatchLegacyRoute() {
  const state = Route.useLoaderData()
  return <LegacyMatchAliasRecovery locale="en" kind={state.kind} />
}
